import { useQuery } from '@tanstack/vue-query'
import { format } from 'date-fns'

import { DATE_FORMAT_LITE } from '~/core/constants'
import { useGolfsService } from '~/core/services'
import type { SearchGolfsDTO } from '~/core/types/golfs'

export function useNearbyGolfs() {
  const { geoLocation } = useLocation()
  const { prices } = useAppInit()
  const { postGolfsSearch } = useGolfsService()

  const searchPayload = computed<SearchGolfsDTO>(() => ({
    prices: prices.value,
    position: geoLocation.value,
    has_promotions: false,
    holes: [],
    distance: 150,
    date: format(Date.now(), DATE_FORMAT_LITE),
    players: 1,
    services: [],
    time_slots: [],
  }))

  // Evite un fetch inutile sur le fallback à 0
  const hasMaxValue = computed(() => searchPayload.value.prices != null && searchPayload.value.prices.max !== 0)

  const canFetchNearbyGolfs = computed(() => hasMaxValue.value && geoLocation.value !== null && !import.meta.server)

  const { data: nearbyGolfs, isFetching } = useQuery({
    enabled: canFetchNearbyGolfs,
    queryKey: ['home', 'nearbyGolfs', searchPayload],
    queryFn: () => postGolfsSearch(searchPayload.value),
  })

  return {
    nearbyGolfs,
    isFetching,
  }
}
